export default "__VITE_ASSET__B_X4utWW__"